import React from 'react';
import { StyleSheet, View } from 'react-native';

import DidItButton from './didit_button';
import ItemButton from './item_button';

import { updateDidItValue } from '../../../services/calendarService';

import { OPComponent } from '../../components';

import COMMON_STYLES from './calendar_item_styles';

export default class CalendarItem extends OPComponent {
  constructor(props) {
    super(props);
  }

  saveDidIt = (didIt) => {
    const item = this.props.item;
    return updateDidItValue(item.eventId, new Date(item.startDate), didIt, item.caseId);
  };

  handlePress = () => {
    this.props.onPress(this.props.item);
  };

  render() {
    let { item, containerStyle, displayType, canEditJustDoIt, isMilitaryEmployer } = this.props;

    const now = Date.now();
    const dateTime = new Date(item.startDate).getTime();
    const diffMillis = now - dateTime;
    const isPast = diffMillis > 0;

    const startDateIso = new Date(item.startDate).toISOString();
    const didItResult = item.eventResults?.find((r) => r.startDate === startDateIso);
    const didIt = didItResult ? didItResult.didIt : null;

    return (
      <View style={[styles.container, !!item.isLast ? { marginBottom: 15 } : null, containerStyle]}>
        <View style={styles.innerContainer}>
          <ItemButton
            item={item}
            onPress={this.handlePress}
            displayType={displayType}
            isMilitaryEmployer={isMilitaryEmployer}
          />
          <DidItButton
            visible={!!isPast}
            saveDidIt={this.saveDidIt}
            editable={canEditJustDoIt}
            didIt={didIt}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  ...COMMON_STYLES,
  innerContainer: {
    // backgroundColor: 'yellow',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
